import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {BusinessProfileComponent} from './business-profile.component';
import {PAGES_AND_PATHS} from '../../../constants/pages-and-paths';
import {AuthGuardService} from '../../../guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.businessProfile.pageInRouting,
    data: {data: PAGES_AND_PATHS.businessProfile},
    component: BusinessProfileComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./business-profile.module').then(m => m.BusinessProfileModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BusinessProfileRoutingModule { }
